import React from "react";

export const ManualOfflineContext = React.createContext();
